var map = {
	"./goldcoin/boost-list-icon-6.png": 85329,
	"./memetown/boost-list-icon-6.png": 34072,
	"./reflection/boost-list-icon-6.png": 84988,
	"./tapcoin/boost-list-icon-6.png": 2970
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26628;